import selectors from 'circe/listing/selectors';
import { getState as getDomainState } from '../selectors';
import { REDUCER_NAME } from './constants';

export const getState = state => getDomainState(state)[REDUCER_NAME];

const getDataState = state => getDomainState(state)[REDUCER_NAME][REDUCER_NAME];

export const {
  getResults,
  getIsFetching,
  getHasNext,
  getCurrentCursor,
  getCache,
  getFromCache,
  getHasCache,
  getFilters,
  getHasPrev,
  getNextCursor,
  getPrevCursor,
} = selectors(getDataState);

export const getResultById = (state, id) => getResults(state).find(creditTerm => creditTerm.creditTerms.id === id);

export const getIsCreating = state => getDataState(state).isCreating;
